export const useStyles = theme => ({
    landingPage: {
        padding: '2em 5em',
        backgroundColor: '#0D6A41',
        height: '100vh',
        [theme.breakpoints.down('sm')]: {
            padding: '1em',
        },
        overflow: 'auto'
    },
    landingTitle: {
        font: 'normal normal 900 98px Maax-Black',
        color: '#fff',
        marginTop: '120px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10vw',
        },
    },
    landingSecond: {
        font: 'normal normal 900 50px Maax-Black',
        color: '#F0B310',
        marginBottom: '20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '5vw',
        },
    },
    landingButton: {
        color: '#0D6A41',
        font: 'normal normal 20px Maax-Black',
        width: '350px',
        height: '100px',
        padding: '10px',
        borderRadius: '10px',
        textAlign: 'center',
        borderColor: '#B4C64C',
        backgroundColor: '#B4C64C',
        '&:hover': {
            backgroundColor: '#0D6A41',
            color: '#B4C64C'
        }
    },
});
  